import React, { useEffect, useState } from "react";
import { FetchLifestyleDeterminants } from "../../../../api/helper";
import { LifestyleDeterminantsdata } from "../../../AgencyFlow/AgencyScreens/Patientinfoeditscreens/Historydata";

const LifeStyleHistory = () => {
  const [islifestyleDeterminants, setislifestyleDeterminants] = useState(false);
  const [LifestyleDeterminants, setLifestyleDeterminants] = useState({
    tobaccoUse: {
      currentEverydaySmoker: false,
      currentSomeDaySmoker: false,
      formerSmoker: false,
      heavyTobaccoSmoker: false,
      lightTobaccoSmoker: false,
      neverSmoker: false,
      smokerCurrentStatusUnknown: false,
      unknownIfEverSmoked: false,
    },
    alcoholUse: {
      doNotDrink: false,
      drinkDaily: false,
      frequentlyDrink: false,
      historyOfAlcoholism: false,
      occasionalDrink: false,
    },
    substanceUse: {
      ivdu: false,
      illicitDrugUse: false,
      noIllicitDrugUse: false,
      prescriptionDrugMisuse: false,
      marijuanaUse: false,
      cocaineUse: false,
      heroinUse: false,
      methamphetamineUse: false,
      hallucinogenUse: false,
      inhalantUse: false,
      stimulantUse: false,
      sedativeUse: false,
      opioidUse: false,
    },
    cardiovascularHealth: {
      eatHealthyMeals: false,
      regularExercise: false,
      takeDailyAspirin: false,
    },
    patternsHistorySubstanceUse: {
      polysubstanceUse: false,
      hxOfSubstanceRehab: false,
      hxOfWithdrawalSymptoms: false,
      affectingDailyLife: false,
      impactingRelationships: false,
      impactingEmployment: false,
      other: false,
    },
    safetyPractices: {
      householdSmokeDetector: false,
      keepFirearmsInHome: false,
      wearSeatbelts: false,
    },
    sexualActivity: {
      exposureToSTI: false,
      nonHeterosexualActivity: false,
      notSexuallyActive: false,
      safeSexPractices: false,
      sexuallyActive: false,
    },
    birthGender: {
      male: false,
      female: false,
      undifferentiated: false,
    },
  });

  
  const GetLifestyleDeterminants = async () => {
    const agencyId = "680b1432319b16c8ea4c1dbf";
    const patientId = "681b328d561a4d17220aad65";
    try {
      const response = await FetchLifestyleDeterminants(agencyId, patientId);
      const data = response?.data?.data;
      if (data && Object.keys(data).length > 0) {
        setLifestyleDeterminants({
          tobaccoUse: data.tobaccoUse || {},
          alcoholUse: data.alcoholUse || {},
          substanceUse: data.substanceUse || {},
          cardiovascularHealth: data.cardiovascularHealth || {},
          patternsHistorySubstanceUse: data.patternsHistorySubstanceUse || {},
          safetyPractices: data.safetyPractices || {},
          sexualActivity: data.sexualActivity || {},
          birthGender: data.birthGender || {},
        });
      }
    } catch (error) {
      console.log("Error fetching lifestyle history:", error);
    }
  };

  useEffect(() => {
    GetLifestyleDeterminants();
  }, []);
  const allFields = [
    ...Object.entries(LifestyleDeterminants.tobaccoUse),
    ...Object.entries(LifestyleDeterminants.alcoholUse),
    ...Object.entries(LifestyleDeterminants.substanceUse),
    ...Object.entries(LifestyleDeterminants.cardiovascularHealth),
    ...Object.entries(LifestyleDeterminants.patternsHistorySubstanceUse),
    ...Object.entries(LifestyleDeterminants.safetyPractices),
    ...Object.entries(LifestyleDeterminants.sexualActivity),
    ...Object.entries(LifestyleDeterminants.birthGender),
  ];

  const trueFields = allFields.filter(([key, value]) => value === true);
  const falseFields = allFields.filter(([key, value]) => value === false);

  const displayedFields = [
    ...trueFields.slice(0, 5),
    ...falseFields.slice(0, 5 - trueFields.length),
  ];

  const renderLifestyleDeterminants = (key, value) => {
    return (
      <div key={key} className="space_between" style={{ marginTop: 19 }}>
        <div className="smoking_txt1">
          {key.replace(/([A-Z])/g, " $1").toUpperCase()}
        </div>
        <div className="smoking_txt1">{value ? "YES" : "NO"}</div>
      </div>
    );
  };

  return (
    <div className="Lifestyle_Determinants_chart1">
      <div className="Lifestyle_Determinants_div1">
        Lifestyle Determinants
        <div
          onClick={() => {
            setislifestyleDeterminants(true);
          }}
        >
          <img
            src={require("../../../assest/Images/pen_icon.png")}
            alt="Pen Icon"
          />
        </div>
      </div>

      {displayedFields.map(([key, value]) =>
        renderLifestyleDeterminants(key, value)
      )}

      {islifestyleDeterminants && (
        <div
          className={`modal_history ${
            islifestyleDeterminants ? "" : "modal_hidden"
          }`}
          id="modal"
        >
          <div className="modal-content_history">
            <div className="modal-header_history">
              <div className="modal-title flex items-center text-red-700 font-semibold text-lg mb-4">
                <span className="material-icons mr-2 text-red-500">🧘</span>
                Lifestyle Determinants
              </div>
              <button
                className="close-btn_history"
                onClick={() => {
                  setislifestyleDeterminants(false);
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body_history" id="modal-body">
              {LifestyleDeterminantsdata.map(
                ({ category, label, options }, index) => (
                  <div className="category_history" key={index}>
                    <h4>{label}</h4>
                    {Object.entries(options).map(([key, optionLabel], i) => (
                      <div key={i} className="flex flex-col gap-1 mb-2">
                        <label className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            disabled
                            checked={LifestyleDeterminants[category][key]}
                          />{" "}
                          {optionLabel}
                        </label>

                        {key.toLowerCase().includes("other") &&
                          LifestyleDeterminants[category][key] && (
                            <input
                              type="text"
                              placeholder="Please specify"
                              className="border p-1 rounded w-full max-w-xs"
                              value={
                                LifestyleDeterminants[category][`${key}Text`] ||
                                ""
                              }
                            />
                          )}
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
            <div className="modal-footer_history">
              <button
                onClick={() => {
                  setislifestyleDeterminants(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LifeStyleHistory;
